import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { adminLogin } from "./adminAuth";
import "./styles/admin.css";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [pw, setPw] = useState("");
    const [showPw, setShowPw] = useState(false);
    const [err, setErr] = useState("");

    const nav = useNavigate();
    const loc = useLocation();

    const onSubmit = (e) => {
        e.preventDefault();
        setErr("");

        // 🔍 DEBUG CONSOLE
        console.group("🔐 Admin Login Debug");
        console.log("Input email:", email);
        console.log("Input password:", pw);

        const ok = adminLogin(email, pw);
        console.log("Login result:", ok);
        console.groupEnd();

        if (!ok) {
            setErr("Login gagal. Semak email & password.");
            return;
        }

        const to = loc.state?.from || "/admin";
        nav(to, { replace: true });
    };

    return (
        <div className="admin-login-wrap">
            <form className="admin-card" onSubmit={onSubmit}>
                <h2>Admin Login</h2>

                <label>Email</label>
                <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="email"
                    autoComplete="username"
                />

                <label>Password</label>
                <div style={{ position: "relative" }}>
                    <input
                        type={showPw ? "text" : "password"}
                        value={pw}
                        onChange={(e) => setPw(e.target.value)}
                        placeholder="password"
                        autoComplete="current-password"
                        style={{ paddingRight: 40 }}
                    />

                    {/* 👁 Toggle mata */}
                    <span
                        onClick={() => setShowPw(!showPw)}
                        style={{
                            position: "absolute",
                            right: 12,
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            opacity: 0.7,
                            userSelect: "none"
                        }}
                        title={showPw ? "Sembunyi password" : "Lihat password"}
                    >
                        {showPw ? "🙈" : "👁️"}
                    </span>
                </div>

                {err && <div className="admin-error">{err}</div>}

                <button className="admin-btn" type="submit">
                    Masuk
                </button>

                <div className="admin-hint">URL: /admin</div>
            </form>
        </div>
    );
}
